module.exports = __webpack_public_path__ + "img/pusko-zarjadnye-ustrojstva.15306377.svg";